<div class="warp" *ngIf="isDataForAllSig$() && questionsData$()?.length else noReply">
    <div>
        <div class="columns-data name-column">
            <div class="header">
                <p translate>data.submissions.done-by</p>
            </div>
            <div class="cube pointer" *ngFor="let recipient of recipients$(),let i = index"
                [ngClass]="{'bottom':i+1==recipients$()?.length}" (click)="viewSubmission(recipient)">
                <que-mini-contact-display [user]="recipient.user" [isData]="true"
                    [mainAnswer]="recipient.mainAnswer"></que-mini-contact-display>
            </div>
        </div>
    </div>
    <div class="table" *ngIf="data$()">
        <div>
            <div class="columns-data date-column">
                <div class="header">
                    <p translate>data.submissions.answered-in</p>
                    <p>-</p>
                </div>
                <div class="cube pointer" *ngFor="let c of recipients$(),let i = index"
                    [ngClass]="{'bottom':i+1==recipients$()?.length}" (click)="viewSubmission(c)">
                    {{c.dateAnswered | queDate}}
                </div>
            </div>
        </div>
        <que-genery-column *ngFor="let question of data$()" class="flex-2"
            [questionData]="question"></que-genery-column>
        <div class="columns-data menu-column">
            <div class="header"></div>
            <div class="cube" *ngFor="let recipient of recipients$(),let i = index"
                [ngClass]="{'bottom':i+1==recipients$()?.length}">
                <que-sumbissions-menu-item [recipient]="recipient"></que-sumbissions-menu-item>
            </div>
        </div>
    </div>
</div>
<ng-template #noReply>
    <que-no-result *ngIf="(!loadingData$() && isLoadedCurretStep$()) else load" [isData]="true"
        [noCommentsForPage]="isDataForAllSig$()"></que-no-result>
</ng-template>
<ng-template #load>
    <div class="load-warp ">
        <div class="load-row" *ngFor="let _ of [].constructor(6)">
            <div class="load-cube" *ngFor="let _ of [].constructor(8),let i=index" [ngClass]="{'first':i==0}"></div>
        </div>
    </div>
</ng-template>